import { agentApi } from "@/api/AgentApi";
import { useQuery } from "@tanstack/react-query";

const queryFn = agentApi.getProfile.bind(agentApi);

export const useAgentProfile = ({ retry = true }: { retry?: boolean }) =>
  useQuery({
    queryKey: ["agent-profile"],
    queryFn,
    retry,
    staleTime: Infinity,
  });
